// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"148":"fdf72148","729":"947ba438","807":"c1765e34"}[chunkId] + ".chunk.css";
};